<template>
  <section class="agenda thursday">
    <div class="agenda__content container">
      <div class="agenda__date">
        <div class="date__container">
          <div>
            <h1 class="date__title">
              Thursday, May 15th
            </h1>
          </div>
          <button class="rotate-btn" v-bind:class="{ 'is-rotated': isRotated, 'iphone-btn': isIphone }"
          @click="seccionVisible = !seccionVisible" v-on:click="toggleRotation">
            <svg :class="{ 'iphone': isIphone }" width="14px" height="9px" viewBox="0 0 18 11">
              <path fill="#3AADCC" d="M9.1,7.8l6.6-6.6C15.8,1.1,16,1,16.1,0.9c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.5,0.1c0.2,0.1,0.3,0.2,0.4,0.3
              s0.2,0.3,0.3,0.4C18,1.8,18,2,18,2.2s0,0.4-0.1,0.5c-0.1,0.2-0.2,0.3-0.3,0.4l-7.5,7.5C9.8,10.8,9.5,11,9.2,11
              c-0.4,0-0.7-0.1-0.9-0.4L0.8,3.1C0.7,3,0.6,2.8,0.5,2.7C0.3,2.5,0.2,2.4,0.2,2.2c0-0.2,0-0.4,0.1-0.5c0.1-0.2,0.2-0.3,0.3-0.4
              S0.9,1.1,1,1c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0,0.5,0.1C2.3,1,2.4,1.1,2.5,1.2L9.1,7.8z"/>
            </svg>
          </button>
        </div>
        <hr class="date__line">
      </div>
      <transition name="fade">
        <div v-show="seccionVisible">
          <div class="cards__container">
            <div class="cards__single grayblue">
              <p class="cards__title">
                Doors Open
              </p>
              <div class="cards__description">
                <p>11:00 AM</p>
              </div>
            </div>
            <div class="cards__single grayblue">
              <p class="cards__title">
                Lunch <br> @ 4th Floor
              </p>
              <div class="cards__description">
                <p>12:30 PM - 2:30 PM</p>
              </div>
            </div>
            <div v-for="(speaker, index) in morningSet" :key="index" class="cards__single cerulean" :class="speaker.class">
              <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
              <div v-if="speaker.logoClass" :class="'logo-img ' + speaker.logoClass"></div>
              <div v-if="speaker.imgClass" class="circle"></div>
              <div class="cards__speaker">
                <p class="cards__name">{{ speaker.name }}</p>
                <p class="cards__spktitle" v-html="speaker.position"></p>
                <p v-if="speaker.title" class="cards__spktitle" v-html="speaker.title"></p>
              </div>
              <div class="cards__description">
                <p class="time">{{ speaker.time }}</p>
                <p v-if="speaker.location" class="location">{{ speaker.location }}</p>
              </div>
            </div>
          </div>
          <dayTwoGrid />
          <div class="cards__container">
            <div v-for="(speaker, index) in afternoonSet" :key="index" class="cards__single cerulean" :class="speaker.class">
              <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
              <div v-if="speaker.logoClass" :class="'logo-img ' + speaker.logoClass"></div>
              <div v-if="speaker.imgClass" class="circle"></div>
              <div class="cards__speaker">
                <p class="cards__name">{{ speaker.name }}</p>
                <p class="cards__spktitle" v-html="speaker.position"></p>
                <p v-if="speaker.title" class="cards__spktitle" v-html="speaker.title"></p>
              </div>
              <div class="cards__description">
                <p class="time">{{ speaker.time }}</p>
                <p v-if="speaker.location" class="location">{{ speaker.location }}</p>
              </div>
            </div>
          </div>
          <div class="cards__container">
            <div class="cards__single cocktail">
              <p class="cards__title">
                Cocktail Hour
              </p>
              <div class="cards__description">
                <p>6:00 PM - 8:00 PM</p>
              </div>
            </div>
            <div class="cards__single dinner">
              <p class="cards__title">
                Whale Supper Club
              </p>
              <div class="cards__description">
                <p>7:30 PM - 9:30 PM</p>
              </div>
            </div>
            <div class="cards__single party">
              <p class="cards__title">
                Legends Never Die Party
              </p>
              <div class="cards__description">
                <p>10:00 PM - 1:00 AM</p>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<style lang="scss">
  @import '@/styles/components/agenda.scss';
</style>

<script>
import dayTwoGrid from './daytwo-grid.vue';

export default {
  name: 'Day One',
  components: {
    dayTwoGrid
  },
  data() {
    return {
      seccionVisible: true,
      isRotated: false,
      isIphone: false,
      morningSet: [
      {
          name: 'Why Decentralized AI Matters At All?',
          title: 'Moderator: Douglas Keeney - CBDO, Wire Network<br> Eric Bravick - CEO, Lifted Initiative<br> Toufic Adlouni - Co-Founder, Renno & Co<br>JD Seraphine - Founder & CEO, Raiinmaker',
          time: '1:00 PM - 1:30 PM',
          class: 'noheight panel'
        },
        {
          name: 'Tokenization and the Evolving Regulatory Landscape to Tokenization, AI, and the Evolving Regulatory Landscape',
          title: 'Moderator: Iñaki Gomez - Counsel, BLG LLP<br>Charlene Cieslik - CCO, Canadian Securities Exchange (CSE)<br>Morva Rohani - Executive Director, Canadian Web3 Council',
          time: '1:30 PM - 2:00 PM',
          class: 'noheight panel'
        },
        {
          name: 'Decentralized AI vs Big Tech: What Does Decentralized AI Need to Win?',
          title: 'David Johnston - Morpheus Core Contributor, Morpheus<br>Ken DiCross - CEO, Wire Network<br>Raj Brahmbhatt - CEO & Co-Founder, Zeebu',
          time: '2:00 PM - 2:30 PM',
          class: 'noheight panel'
        },
        {
          name: 'AI Agent Demo: Scrypted & h011yw00d',
          title: 'Rahilla Zafar - Co-Founder, h011yw00d<br> Tim Cotten - Co-Founder, Scrypted',
          time: '2:30 PM - 3:00 PM',
          class: 'noheight panel'
        },
                {
          name: 'BitTensor and the AI Economy: Decentralizing Intelligence, Redefining Value',
          title: 'Chris Miglino - CEO & Co-Founder, DNA',
          time: '3:00 PM - 3:30 PM',
          class: 'noheight panel'
        },
        {
          name: 'DNA: Pentagon / Pact Swap / Backstage ',
          title: 'Chris Miglino - CEO & Co-Founder, DNA<br>Idon Liu - CBO, Pentagon Games<br>Stephen Morris, - CEO, Pact Swap<br>Mauricio Silvestris - CEO & Founder, Backstage Global',
          time: '3:30 PM - 4:00 PM',
          class: 'noheight panel'
        }
      ],
      afternoonSet: [
        {
          name: 'Scaling autonomous AI agents: What needs to happen?',
          title: 'Moderator: Douglas Keeney - CBDO, Wire Network<br>Ken DiCross - CEO, Wire Network<br>Ethan Jackson - Co-Founder, Theoriq<br>Tim Cotten - Co-Founder, Scrypted<br>Ben Fielding - Co-Founder & CEO, Gensyn AI',
          time: '4:30 PM - 5:00 PM',
          class: 'noheight panel'
        },
        {
          name: 'Redefining on-chain privacy with Midnight',
          title: 'Moderator: Fahmi Syed - President, Midnight Foundation<br>Eran Barak - CEO, Midnight<br>Bob Blessing-Hartley - Head of Architecture, Midnight<br>Dr. Benjamin Beckmann - CTO, Midnight',
          time: '5:00 PM - 5:30 PM',
          class: 'noheight panel'
        },
        {
          name: 'The Decentralized AI Trust Layer: How Personal AI and Web3 Insurance Enable Mass Participation',
          title: 'Moderator: Tricia Wang - CEO, DAIS<br>Christian Davies - Global Head of Distribution and Innovation, Relm Insurance<br>Syed Hussain - Founder & CEO, Shiza',
          time: '5:30 PM - 5:50 PM',
          class: 'noheight panel'
        },
        {
          name: 'Vision in Action: Scaling Polymath’s Global Impact',
          title: 'Moderator: Vincent Kadar - CEO, Polymath<br>Natalie Hirsch - CFO, Polymath<br>Andrew Howarth - Partner, Walkers LLP',
          time: '5:50 PM - 6:00 PM',
          class: 'noheight panel'
        },
        {
          name: 'Fireside Chat - From Exchange Floors to Blockchain: The New Era of Regulated Security Tokens',
          title: 'Richard Carleton - CEO, Canadian Securities Exchange<br>Vince Kadar - CEO, Polymath',
          time: '6:00 PM - 8:00 PM',
          class: 'noheight panel'
        },
        /*{
          name: 'Live from CLIO – Blockchain North Stream with Florent',
          title: 'Freemium Frenzy: Can Free Access Fuel Blockchain Adoption?<br>Tokenization 101: Your Front-Row Pass to the Future of Finance<br>The Great Unlock: How Tokenization is Democratizing Finance',
          time: '6:00 PM - 8:00 PM',
          class: 'noheight panel'
        }*/
      ]
    }
  },
  methods: {
    toggleRotation() {
      this.isRotated = !this.isRotated;
    },
  },
  mounted() {
    this.isIphone = /iPhone/.test(navigator.userAgent);
  }
};
</script>
